// /go/import/{india|china}: where the Adyvance Import Helper extension sends a vendor who clicked Order
// on an IndiaMART or Alibaba product. Signed in: straight to Import Marketplace's India or China section
// (the extension then hands the product over). Signed out: to sign-in first, with a note saying why;
// the destination is kept for this tab so sign-in methods that return to "/" (Google) still resume it.
import { useEffect } from "react";
import { useParams } from "@tanstack/react-router";
import { useMe } from "../api/queries";
import { isUnauthenticated } from "../api/errors";
import { useGo } from "../shell/AppLink";
import { defaultStore } from "../shell/context";

const RESUME = "ady.resume";
/** Also used by the AI app consent page (/connect/authorize, D-090). */
export const RESUME_KEY = RESUME;
/** The Import Marketplace section to open next (the router drops a ?tab= on redirect). */
export const OPEN_TAB = "ady.import.tab";

/** After sign-in: the address to continue to, once (set by /go/import or /connect/authorize). */
export function takeResume(): string | null {
  try {
    const v = sessionStorage.getItem(RESUME);
    sessionStorage.removeItem(RESUME);
    return v && (/^\/go\/import\/(india|china)$/.test(v) || /^\/connect\/authorize\?[^#]*$/.test(v))
      ? v
      : null;
  } catch {
    return null;
  }
}

export function GoImport() {
  const { site } = useParams({ strict: false }) as { site?: string };
  const tab = site === "china" ? "china" : "india";
  const me = useMe();
  const go = useGo();
  useEffect(() => {
    if (me.isError && isUnauthenticated(me.error)) {
      const here = `/go/import/${tab}`;
      try {
        sessionStorage.setItem(RESUME, here);
      } catch {
        // private window: the ?next= address still works for email sign-in
      }
      go(`/sign-in?next=${encodeURIComponent(here)}`);
    } else if (me.data) {
      const d = defaultStore(me.data);
      try {
        sessionStorage.setItem(OPEN_TAB, tab);
      } catch {
        // private window: the page opens on Marketplace; the product still switches it to the order
      }
      go(d ? `/${d.org}/${d.store}/services/import-marketplace` : "/onboarding");
    }
  }, [me.isError, me.error, me.data, go, tab]);
  return <div className="min-h-dvh bg-canvas" aria-busy="true" />;
}
